import { Map } from 'immutable';
 
const actionTypes = Map({
    SUBWORKFLOW: 'SubWorkflow',
    MUTATION: 'Mutation',
    EMAIL: 'Email',
    ASSIGNVALUE: 'AssignValue'
});

export default actionTypes;